import { auth, signInWithEmailAndPassword, createUserWithEmailAndPassword, onAuthStateChanged, signOutAuth, sendPasswordResetEmail } from '../firebase'

const cache = JSON.parse(localStorage.getItem('user') || 'null')
export const user = new Proxy({ value: cache }, {
  set(target, key, value) {
    if (value) {
      save(value)
    } else {
      clean()
    }
    return Reflect.set(...arguments)
  }
})

const save = (user) => {
  const {
    accessToken,
    displayName,
    email,
    emailVerified,
    phoneNumber,
    photoURL,
    uid
  } = user
  localStorage.setItem('user', JSON.stringify({
    accessToken,
    displayName,
    email,
    emailVerified,
    phoneNumber,
    photoURL,
    uid
  }))
}

const clean = () => {
  localStorage.removeItem('user')
}

export const signIn = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password)
}

export const signUp = (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password)
}

export const restore = (email) => {
  return sendPasswordResetEmail(auth, email)
}

export const signOut = () => {
  return signOutAuth(auth)
}


export const listen = cb => onAuthStateChanged(auth, state => {
  cb(state)
})

export const isAdmin = async () => {
  return user.value && user.value.getIdTokenResult().then(r => r.claims ? r.claims.admin : false)
}

onAuthStateChanged(auth, state => {
  user.value = state
  isAdmin().then(admin => {
    if (state) {
      state.admin = admin
      user.value = state
    }
  })
})